import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

let globalHistory: ReturnType<typeof useHistory>

export const GlobalHistory: React.FC = () => {
	const history = useHistory()
	useEffect(() => {
		globalHistory = history
	}, [history])
	return null
}
/**
 * @deprecated for sagas use selectHistory from 'Store' + routerActions from 'connected-react-router',
 * for components use useHistory, useLocation, etc. from 'react-router-dom'
 */
export const getHistory = () => globalHistory
